export default {
    "The online prints tool is loading. Please wait": "Strumento di stampa online in caricamento. Attendi",
    "Add photos": "Aggiungi foto",
    "Options": "Opzioni",
    "Extras": "Altro",
    "Upload your photos": "Carica le tue foto",
    "Get started! Upload some photos": "Inizia: carica alcune foto",
    "We’re analyzing your photos for the next step. Analyzing photos %s of %s": "Analisi delle foto per il passaggio successivo. Analisi delle foto %s di %s",
    "%s You’ve already uploaded this photo.": "%s Foto già caricata.",
    "We couldn’t read the image ‘%s’ so it will not be included in your image collection. This might happen if the file is not an image file (for example a jpeg or png), or because the image is broken. Please check the file and try to re-upload it": "Impossibile leggere l’immagine ‘%s’: non verrà inclusa nella raccolta di immagini. È probabile che il file non sia un file immagine (ad es. jpeg o png) o che l’immagine sia danneggiata. Controlla il file e prova a caricarlo di nuovo.",
    "We couldn’t upload the image ‘%s’ because you tried to upload a file type the editor doesn’t support. Supported types are ‘%s’.": "Impossibile caricare l’immagine ‘%s’: questo tipo di file non è supportato dall’editor. I tipi di file supportati sono ‘%s’.",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum file size is %s.": "Impossibile caricare l’immagine ‘%s’ perché è troppo grande. La dimensione massima dei file è %s.",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum allowed dimensions are %s x %s pixels.": "Impossibile caricare l’immagine ‘%s’ perché è troppo grande. La dimensione massima consentita è di %s x %s pixel.",
    "Could not upload ‘%s’ because of error: %s. See console for more info.": "Impossibile caricare ‘%s’ a causa dell’errore: %s. Per maggiori informazioni, fare riferimento alla console.",
    "Upload more photos": "Carica altre foto",
    "Your photos are uploading: %s of %s complete": "Foto in caricamento: completato %s di %s",
    "Photos added: ‘%s’ to your collection": "Foto aggiunte: ‘%s’ alla tua raccolta",
    "%s of %s uploaded": "Caricate %s di %s",
    "Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us.": "Impossibile visualizzare la foto. Prova a eliminarla e a caricarla di nuovo. Se non viene ancora visualizzata, contattaci.",
    "Your photo collection": "La tua raccolta di foto",
    "Tap here to change photo format, add a filter or change quantity, for all photos in this order": "Tocca qui per cambiare il formato foto, aggiungere un filtro o modificare la quantità per tutte le foto di questo ordine",
    "Swipe to reveal more options": "Scorri per visualizzare altre opzioni",
    "We will make you aware if images are low resolution and notify you when cropping will occur.": "Ti indicheremo se le immagini sono a bassa risoluzione e se verranno ritagliate.",
    "Edit your photos": "Modifica le foto",
    "You’re ordering %s photos": "Stai ordinando %s foto",
    "Low resolution images": "Immagini a bassa risoluzione",
    "You’ve uploaded one or more images at low resolution. These images might see loss in quality in print.": "Hai caricato una o più immagini a bassa risoluzione. La loro qualità potrebbe ridursi durante la stampa.",
    "For better results, choose a smaller print size. Low resolution images have been marked with the icon displayed above.": "Per risultati migliori, scegli un formato di stampa più piccolo. Le immagini a bassa risoluzione sono contrassegnate dall’icona mostrata in alto.",
    "One or more photos have been cropped to fit the selected print size.": "Sono state ritagliate una o più foto per adattarle al formato di stampa selezionato.",
    "Cropped photos have been marked with the icon displayed above. We recommend that you check your cropped photos before ordering.": "Le foto ritagliate sono contrassegnate dall’icona mostrata in alto. Ti consigliamo di controllare le foto ritagliate prima di ordinarle.",
    "Cannot show photo. Please try deleting and uploading it again. If it still doesn’t show, please contact us.": "Impossibile visualizzare la foto. Prova a eliminarla e a caricarla di nuovo. Se non viene ancora visualizzata, contattaci.",
    "Duplicate photo": "Duplica",
    "Cropped photos": "Foto ritagliate",
    "Info": "Informazioni",
    "More info": "Maggiori informazioni",
    "Total": "Totale",
    "Price per print": "Prezzo per stampa",
    "Finish your order": "Completa l’ordine",
    "Save and finish later": "Salva e termina più tardi",
    "Got it!": "Capito!",
    "Low resolution image": "Immagine a bassa risoluzione",
    "Photo cropped": "Foto ritagliata",
    "Standard sizes": "Formati standard",
    "Enlargements": "Ingrandimenti di foto",
    "Edit": "Modifica",
    "Save": "Salva",
    "Reset": "Ripristina",
    "Original": "Originale",
    "Sephia": "Seppia",
    "B/W": "B/N",
    "Black and white": "Bianco e nero",
    "Edit all": "Modifica tutte",
    "Done": "Fatto",
    "Select filter": "Seleziona filtro",
    "Close": "Chiudi",
    "Add filter": "Aggiungi filtro",
    "List of available filters...": "Elenco dei filtri disponibili...",
    "Select format": "Seleziona il formato",
    "Choose size": "Scegli la dimensione",
    "Size:": "Dimensione:",
    "Editing multiple photos will be available when all the photos are analyzed": "Dopo l’analisi di tutte le foto sarà possibile modificarle",
    "Amount": "Quantità",
    "Prints": "Stampe",
    "Cannot show photo. Please try deleting and uploading it again and, if it still doesn’t show, please contact us for assistance.": "Impossibile visualizzare la foto. Prova a eliminarla e a caricarla di nuovo. Se non viene ancora visualizzata, contattaci per richiedere assistenza.",
    "Do more with your photos": "Ottieni di più dalle tue foto",
    "Order your prints": "Ordina le stampe",
    "Enlarge": "Ingrandisci",
    "%s photos": "Foto %s",
    "Adding cart items. Two more steps...": "Aggiunta di articoli nel carrello. Mancano solo due passaggi...",
    "We’re processing your order. One more step…": "Stiamo elaborando il tuo ordine. Ancora un passaggio…",
    "Redirecting to cart. Just a moment...": "Indirizzamento al carrello. Un attimo di pazienza...",
    "Paper": "Carta",
    "Other": "Altro",
    "Are you sure you want to delete this product from your shopping basket?": "Eliminare il prodotto dal carrello?",
    "Something went wrong when adding items to cart. See details below.": "Si è verificato un errore durante l’aggiunta degli articoli nel carrello. Vedi i dettagli di seguito.",
    "Image enhancement will automatically optimise your images, bringing out the colour in every photo. We recommend disabling this option if you’ve already enhanced your photos with other software or apps, such as Instagram.": "Il miglioramento delle immagini ottimizzerà automaticamente le immagini, esaltando il colore in ogni foto. Disattiva questa opzione se le foto sono già state migliorate con altri software o app, come ad esempio Instagram.",
    "You're ordering 1 print.": "Stai ordinando 1 stampa.",
    "Your device has lost internet connection": "",
    "Delete?": "",
    "Yes": "",
    "No": "",
    "The maximum allowed number of photos is %s but you can add multiple orders to one cart and buy all your photos at once. To order more, add this order to your cart then return to the editor.": "Il numero massimo consentito di foto è %s, ma è possibile aggiungere più ordini nel carrello e acquistare tutte le foto insieme. Per ordinarne di più, aggiungi questo ordine nel carrello e torna all’editor.",
    "For you to order, we need to finish uploading your photos": "",
    "%s premium prints": "",
    "Retro": "",
    "We’re sorry: we couldn’t registrer file %s, so we’ve removed it from your order. This might be a temporary error and you could try uploading it again": "",
    "Customer service": "Assistenza clienti",
    "Privacy": "Privacy",
    "Disclaimer": "Avvertenza",
    "Use photos from minnebanken": "Utilizza foto da minnebanken",
    "Please log in with": "",
    "Memory bank": "",
    "%s photos selected": "",
    "Timeline": "",
    "Events": "",
    "Collections": "",
    "Import photos": "",
    "Choose collection": "",
    "Choose event": "",
    "Unable to get photos": "",
    "No photos": "",
    "More photos...": "",
    "Unable to get timeline data": "",
    "Unable to get events data": "",
    "Unable to get collections data": "",
    "No timelines": "",
    "No events": "",
    "No collections": "",
    "January": "",
    "February": "",
    "March": "",
    "April": "",
    "May": "",
    "June": "",
    "July": "",
    "August": "",
    "September": "",
    "October": "",
    "November": "",
    "December": "",
    "All months": "",
    "All days": "",
    "Click here to add polaroid text": "Puoi aggiungere il testo qui",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser, order fewer photos at a time or first upload to Photo Organiser.": "Impossibile ridimensionare la foto. È probabile che il browser sia sovraccaricato da tante foto di grandi dimensioni. Prova con un browser differente oppure ordina meno foto insieme o carica per primo Photo Organiser.",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser or order fewer photos at a time.": "Impossibile ridimensionare la foto. È probabile che il browser sia sovraccaricato da tante foto di grandi dimensioni. Prova con un browser differente oppure ordina meno foto insieme.",
    "Could not load photos from Photo Organiser because there are no photos in the basket.": "Impossibile caricare le foto da Photo Organiser: non ci sono foto nel carrello.",
    "Please know that if you leave the page now, your changes will be lost": "",
    "Quantity:": "",
    "Loading photos from minnebanken...": "Caricamento delle foto da minnebanken...",
    "Select all": "",
    "Select nothing": "",
    "Check your photos": "Controlla le foto",
    "Loading...": "",
    "Loading, please wait": "Attendi… ci siamo quasi.",
    "%s images have a low-resolution warning. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s immagini hanno un avviso relativo alla bassa risoluzione. Ricontrolla le foto contrassegnate da questo avviso. In caso contrario, non possiamo garantire la massima qualità delle stampe.",
    "%s photos have been cropped and not validated. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s foto sono state ritagliate, ma non approvate. Ricontrolla le foto contrassegnate da un avviso. In caso contrario, non possiamo garantire la massima qualità delle stampe.",
    "Some photos need attention": "È necessario controllare alcune foto",
    "Continue": "Continua",
    "Check photos": "Controlla le foto",
    "Check your cropped photos": "Controlla le foto ritagliate",
    "Check your low resolution images": "Controlla le tue immagini a bassa risoluzione",
    "Unable to load images from temporary selection API in Photo Organise": "",
    "Unfortunately your browser does not support all options for creating this product. Please install Safari, Chrome, Firefox or a newer version of Internet Explorer (11 or Edge) and start again.": ""
 };
 
